export const content_fi_FI_NR = {
  tacLabel: 'Hyväksyn että Nordrum tallentaa sekä voi käyttää yhteystietojani GDPRn mukaisesti.',
  tacError: 'Sinun täytyy hyväksyä ehdot',
  submitButton: 'Lähetä',
  imageAlt: 'Lomakekuva',
  formNotFound: 'Emme valitettavasti löytäneet lomaketta.',
  formNotStarted: 'Lomake ei ole saatavilla vielä.',
  formExpired: 'Lomake ei ole enää saatavilla.',
  soonForwarded: 'Sinut siirretään osoitteeseen',
  contactDetails: 'Yhteystiedot',
  loading: 'Lataa lomaketta',
  posting: 'Lähettää vastausta',
  preview: 'Esikatselu',
  errors: {
    'Forbidden - XSS warning':
      'Moikka! Kirjoititkohan kenties väärin? Tarkistathan että vastauksiin ei ole eksynyt omituisia symboleja kuten "<" tai ">" ja kokeile uudestaan!',
    noFormUID: 'Lomake-ID puuttuu',
    noData: 'Lomakedata puuttuu tai ei ole saatavilla',
  },
  contactLabels: {
    heading: 'Yhteystiedot',
    name: 'Koko nimi',
    address: 'Katuosoite',
    city: 'Paikkakunta',
    postalCode: 'Postinumero',
    phone: 'Puhelinnumero',
    email: 'Sähköposti',
  },
  countryCode: '+358 ',
  errorMessages: {
    name: {
      tooLong: 'Nimessä on liikaa merkkejä.',
    },
    address: {
      tooLong: 'Katuosoitteessa on liikaa merkkejä.',
    },
    postalCode: {
      tooLong: 'Postinumerossa on liikaa merkkejä.',
    },
    city: {
      tooLong: 'Paikkakunnassa on liikaa merkkejä.',
    },
    phone: {
      invalid: 'Anna oikea puhelinnumero',
      tooShort: 'Puhelinnumerosi sisältää liian vähän merkkejä',
      tooLong: 'Puhelinnumerossa on liikaa merkkejä.',
    },
    email: {
      invalid: 'Ole hyvä ja syötä toimiva sähköpostiosoite',
      tooLong: 'Sähköpostiosoitteessa on liikaa merkkejä.',
    },
  },
};
